// extracted by mini-css-extract-plugin
export default {"icon":"SettingsArrow_icon__zJIr2","collapsed":"SettingsArrow_collapsed__WnAeh"};